// src/pages/Subheadquarter/ViewSubheadquarter.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import subheadquarterService from '../../services/subHeadquarter.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const ViewsSubheadquarter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subhq, setSubhq]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast]     = useState(null);

  useEffect(() => {
    const fetchSubHQ = async () => {
      try {
        const res = await subheadquarterService.getSubheadquarterById(id);
        if (res.success) setSubhq(res.data);
      } catch (err) {
        setToast({ message: 'Failed to fetch subheadquarter details', type: 'error' });
      } finally {
        setLoading(false);
      }
    };
    fetchSubHQ();
  }, [id]);

  if (loading) return <div className="add-headquarter-page"><p style={{ padding: 40 }}>Loading...</p></div>;
  if (!subhq)     return <div className="add-headquarter-page"><p style={{ padding: 40 }}>Subheadquarter not found.</p></div>;

  const formatDate = (val) => {
    if (!val) return null;
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const Field = ({ label, value }) => (
    <div className="form-group">
      <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
      <div className="form-input" style={{
        background: '#f8f9fa', cursor: 'default',
        minHeight: 42, display: 'flex', alignItems: 'center',
      }}>
        {value || <span style={{ color: '#aaa' }}>—</span>}
      </div>
    </div>
  );

  return (
    <div className="add-headquarter-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/subheadquarter/view">Subheadquarters</a></li>
          <li className="breadcrumb-item active">View Subheadquarter</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Subheadquarter Details</h4>
        <button 
          className="btn btn-primary"  
          onClick={() => navigate(`/subhq/edit/${id}`)}
        >
          ✏️ Edit Subheadquarter
        </button>
      </div>

      <div className="form-card">
        <div className="form-section">
          <div className="form-row">
            <Field label="Subheadquarter Name" value={subhq.name} />
            <Field label="Region"              value={subhq.region?.name} />
            <Field label="Company"             value={subhq.company?.name} />
          </div>
          <div className="form-row">
            <Field label="Status"      value={subhq.isActive ? '✅ Active' : '❌ Inactive'} />
            <Field label="Created On"  value={formatDate(subhq.createdAt)} />
            <Field label="Updated On"  value={formatDate(subhq.updatedAt)} />
          </div>
        </div>

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/subheadquarter/view')}>← Back</button>
          <button className="btn btn-primary"    onClick={() => navigate(`/subhq/edit/${id}`)}>✏️ Edit</button>
        </div>
      </div>
    </div>
  );
};

export default ViewsSubheadquarter;